import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '需求描述',
    type: 'BRF_SYS_DESC',
}
